import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import React, { useContext, useMemo } from 'react';
import { MatchContentWithProvider } from './MatchContent';

export const MatchesDate = React.memo(({
  dateKey,
  levelKey,
  sectionKey,
  matchDisplayType,
  matchScheduleDisplayType,
  forPlayoffs,
  matches,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {};
  const {
    scheduleLevelKeys: _scheduleLevelKeys,
    levelSectionDateMatches: _levelSectionDateMatches,
    scoreboardByDate: _scoreboardByDate,
    playoffScoreboardByDate: _playoffScoreboardByDate
  } = matches_groupInfo ?? {};

  const lsdms = _levelSectionDateMatches?.[levelKey]?.[dateKey]?.[sectionKey]

  const sortedMatches = _.orderBy(
    _.values(lsdms || {}),
    [
      match => !!match?.results,
      match => match?.home?.name?.toLowerCase() || ''
    ],
    ['desc', 'asc']
  );

  const dateMatches = useMemo(() => {
    if (forPlayoffs) return;
    if (_.isEmpty(sortedMatches)) return <div className='match-wrapper'>No Matches</div>;
    return _.map(sortedMatches, (match) => (
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  }, [JSON.stringify(lsdms)])

  const datePlayoffMatches = useMemo(() => {
    if (!forPlayoffs) return;
    if (_.isEmpty(_playoffScoreboardByDate)) return <div>No Playoff Matches</div>;
    return _.map(matches, (match) => (
      <MatchContentWithProvider
        dateKey={dateKey}
        levelKey={levelKey}
        sectionKey={sectionKey}
        key={match._itemKey}
        matchKey={match._itemKey}
        match={match}
        matchDisplayType={matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      />
    ));
  }, [JSON.stringify(_playoffScoreboardByDate)])

  return forPlayoffs ? datePlayoffMatches : dateMatches

})

